import styles from './Marcas.module.css';
import CarruselLogos from '../../UI/CarruselLogos';
import { useScrollAnimation } from '../../../ganchos/usarAnimacionScroll';
import marcas from '../../../datos/marcas.json';

const SeccionMarcas = () => {
  const [seccionRef, esVisible] = useScrollAnimation({ threshold: 0.05 });

  return (
    <section
      id="marcas"
      ref={seccionRef}
      className={`${styles.seccion} ${esVisible ? styles.visible : ''}`}
    >
      <div className={styles.encabezado}>
        <h2 className={styles.titulo}>Nuestras <span className={styles.acento}>Marcas</span></h2>
        <div className={`${styles.lineaTitulo} ${esVisible ? styles.lineaVisible : ''}`} />
        <p className={styles.subtitulo}>
          Distribuimos y representamos las marcas líderes en equipos de limpieza industrial a nivel mundial.
        </p>
      </div>
      <CarruselLogos items={marcas} carpeta="marcas" velocidad={0.5} />
    </section>
  );
};

export default SeccionMarcas;
